<template>
	<div>
		<content-list-data :key="id" :list="id" :search="data_search" v-if="id != 'default'"></content-list-data>

		<v-btn class="deep-orange" v-if="id != 'default'" fab dark small fixed top right style="top: 90px; right: 26px;" :style="{'top': ($compact_view() ? '84px' : '90px'), 'right': ($compact_view() ? '36px' : '26px')}" @click.stop="open_add_data"><v-icon>add</v-icon></v-btn>
    <v-toolbar v-if="id != 'default'" :color="$dark() ? 'grey darken-4' : 'white'" fixed dense right style="top: 87px; left: auto; right: 90px; max-width: 300px;">
      <v-text-field color="deep-orange" prepend-icon="search" v-model="data_search" ref="search_field" clearable hide-details single-line></v-text-field>
    </v-toolbar>

	</div>
</template>

<script>
import ContentListData from './Data'

export default {
	props: ["id"],
	components: {
		ContentListData
	},
	watch: {
		"id": function(newValue) {
			this.$forceUpdate();
		}
	},
	data () {
		return {
			data_search: ""
		}
	},
	methods: {
		open_add_data () {
      this.$router.push("/content/list/"+this.id+"/data/new");
    }

	}
}
</script>